import React, { Component } from 'react';

import Wrapper from '../../../hoc/Wrapper/Wrapper';
import Backdrop from '../Backdrop/Backdrop';

import classes from './FilterDropDown.module.css';
import CheckIconWhite from '../../../assets/icons/check-white.svg';
import SearchIconBlue from '../../../assets/icons/search-icon-blue.svg';
import { IsListEmpty } from '../../../utilities/CommonMethods';

// Props List :-
// itemList = List of menu items in the dropdown. For eg, [{id: , label:}, ...]
// activeItem = selected item from the dropdown list
// onDropDownItemClicked = Handles the click of dropdown item
// onDropDownClicked = Handles the click of dropdown

class FilterDropDown extends Component {
    state = {
        activeItem: -1,
        searchFieldValue: ''
    }

    componentDidMount() {
        if (this.props.activeItem > -1) {
            this.setState({ activeItem: this.props.activeItem, searchFieldValue: this.props.searchString })
        } else {
            this.setState({ searchFieldValue: this.props.searchString });
        }
    }

    onDropDownItemClicked = (pos) => {
        this.setState({ activeItem: pos });
        this.props.onDropDownItemClicked(pos, this.props.forNumber);
    }

    inputChangeHandler = (event) => {
        let updatedValue = event.target.value;
        this.setState({ searchFieldValue: updatedValue });
    }

    onInputKeyUp = (event) => {
        if (event.keyCode === 13) {
            this.props.onSearchIconClick(this.state.searchFieldValue);
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.activeItem !== this.props.activeItem) {
            if (this.props.activeItem === -1) {
                this.setState({ activeItem: -1 });
            } else if (this.props.activeItem === 'reset' && this.props.resetDropDown) {
                this.setState({ activeItem: 0 });
            }
        }
        if (prevProps.searchString !== this.props.searchString) {
            this.setState({ searchFieldValue: this.props.searchString })
        }
    }

    render() {
        const itemList = !IsListEmpty(this.props.itemList) ? this.props.itemList.map((item, pos) => {
            const isActive = (pos === this.state.activeItem);
            return (
                <div key={pos} className={classes.DropDownListItem} onClick={() => this.onDropDownItemClicked(pos)}>
                    <div className={[classes.CheckIconDiv, isActive ? classes.Active : null].join(' ')}>
                        <img src={CheckIconWhite} alt="Option Checked Icon"
                            className={[classes.CheckIcon, isActive ? classes.ShowImage : null].join(' ')} />
                    </div>
                    <p> {item.label} </p>
                </div>
            )
        }) : [];

        return (
            <Wrapper>
                <div className={classes.Backdrop}>
                    <Backdrop visible={true} transparent={true} backdropClicked={this.props.onDropDownClicked} />
                </div>
                {this.props.forReports
                    ? <div className={classes.DropDownContainer}>
                        <p className={[classes.DropdownHeading, classes.SearchHeading].join(' ')}>SEARCH
                            <span className={classes.ClearText} onClick={this.props.clearSearchResults}>CLEAR</span></p>
                        <div className={classes.SearchInputContainer}>
                            <input
                                type="text"
                                onChange={(event) => this.inputChangeHandler(event)}
                                onKeyUp={(event) => this.onInputKeyUp(event)}
                                value={this.state.searchFieldValue}
                                className={classes.SearchInput} />
                            <img src={SearchIconBlue} alt="Option Checked Icon"
                                className={classes.SearchIcon}
                                onClick={() => this.props.onSearchIconClick(this.state.searchFieldValue)} />
                        </div>
                    </div>
                    : <div className={classes.DropDownContainer}>
                        <p className={classes.DropdownHeading}>SORT BY</p>
                        <div className={[classes.DropDownList, this.props.forNumber ? classes.RemoveMargin : ''].join(' ')}>
                            {itemList}
                        </div>
                        {
                            this.props.forNumber
                                ? null
                                : <>
                                    <p className={[classes.DropdownHeading, classes.SearchHeading].join(' ')}>SEARCH
                                        <span className={classes.ClearText} onClick={this.props.clearSearchResults}>CLEAR</span></p>
                                    <div className={classes.SearchInputContainer}>
                                        <input
                                            type="text"
                                            onChange={(event) => this.inputChangeHandler(event)}
                                            onKeyUp={(event) => this.onInputKeyUp(event)}
                                            value={this.state.searchFieldValue}
                                            className={classes.SearchInput} />
                                        <img src={SearchIconBlue} alt="Option Checked Icon"
                                            className={classes.SearchIcon}
                                            onClick={() => this.props.onSearchIconClick(this.state.searchFieldValue)} />
                                    </div>
                                </>
                        }

                    </div>
                }

            </Wrapper>
        );
    }
}

export default FilterDropDown;